<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      @click="openDrawerVacaciones"
      type="primary"
      icon="el-icon-plus"
      circle
      :disabled="!AllowCreateVacations"
    ></el-button>
    <div style="display: flex; float: right">
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Período"
        placement="top"
      >
        <el-select
          v-model="year"
          placeholder="Año"
          size="mini"
          @change="handleChangeYear"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-tooltip>
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Dirección"
        placement="top"
      >
        <DirectionSelector
          v-if="
            this.currentUser.EmployeeId == 37 ||
            this.IsInRoles([this.roles.GerenteRRHH])
          "
          @selection-change="handleChangeDirection"
        ></DirectionSelector>
      </el-tooltip>
    </div>
    <div style="text-align: center; margin-bottom: 20px">
      <label><b>PENDIENTES POR APROBAR:</b></label>
      <br />
      <label
        :style="PeddingRequestAproveRRRHH > 0 ? 'color: red' : 'color: black'"
        ><b>RRHH:</b> {{ PeddingRequestAproveRRRHH }}</label
      >
      <br />
      <label
        :style="PeddingRequestAproveSuper > 0 ? 'color: red' : 'color: black'"
        ><b>SUPERVISOR:</b> {{ PeddingRequestAproveSuper }}</label
      >
    </div>
    <div>
      <rabbey-table-3
        ref="table"
        :loading="autoLoading"
        :data="VacationData"
        :columns="ColumnsVacation"
        show-summary
        :summary-method="getSummaries"
      ></rabbey-table-3>
    </div>
    <ColorInfot :ColorAndDescription="colorInfot" style="margin-top: 2%" />
    <AddRequestVacation
      ref="AddRequestVacation"
      :drawerVacacionesOrigen.sync="drawerVacaciones"
      :before-close="closeDrawerVacaciones"
      @dialog-closed="closeDrawerVacaciones"
      @refreshTable="getDataVacations"
      :dataVacaciones="VacationData"
    >
    </AddRequestVacation>
    <VacacionesReportForMes
      :showDrawerVacacionesReport="showDrawerVacationReport"
      :UserId="IdUser"
      :Month="Month"
      :year="year2"
      @dialog-closed="closeDrawerDetalles"
      :before-close="closeDrawerDetalles"
      @refreshTable2="getDataVacations"
    ></VacacionesReportForMes>
  </div>
</template>

<script>
import ColumnsVacations from "@/columns/ColumnsVacations";
import AddRequestVacation from "@/views/apps/employees/RRHH/Modules/Vacation/DrawerVacaciones.vue";
import VacacionesReportForMes from "@/views/apps/employees/RRHH/Modules/Vacation/VacacionesReportForMes.vue";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";

//helpers
import ColorInfot from "@/views/apps/employees/RRHH/Modules/Permission/helpers/ColorInfot.vue";
import GetPendingRequestAproved from "@/views/apps/employees/RRHH/Modules/GetPendingRequestAproved.js";

export default {
  name: "Vacaciones",
  components: {
    AddRequestVacation,
    DirectionSelector,
    VacacionesReportForMes,
    ColorInfot
  },
  data() {
    return {
      ColumnsVacation: ColumnsVacations,
      VacationData: [],
      drawerVacaciones: false,
      drawerVacacionesMes: false,
      autoLoading: false,
      directionId: 0,
      Month: 0,
      IdUser: 0,
      year: new Date().getFullYear(),
      showDrawerVacationReport: false,
      year2: 0,
      PeddingRequestAproveRRRHH: 0,
      PeddingRequestAproveSuper: 0,
      EmployeeData: [],
      AllowCreateVacations: false,
      InitDateEmployee: null,
      colorInfot: [
        {
          Color: "rgba(234, 22, 22, 0.301)",
          Description: "Solicitado sin Aprobación"
        },
        {
          Color: "rgba(231, 235, 5, 0.377)",
          Description: "Aprobado por supervisor"
        },
        { Color: "rgba(2, 255, 107, 0.459)", Description: "Aprobado por RRHH" },
        { Color: "rgba(25, 133, 187, 0.281)", Description: "Ejecutado" },
        { Color: "rgba(167, 124, 32, 0.473)", Description: "Rechazado" }
      ]
    };
  },
  computed: {
    years() {
      const lowLevel = 2021;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 2; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  },
  methods: {
    getDataVacations() {
      this.autoLoading = true;
      GetPendingRequestAproved(this, 1);
      let employeeID =
        this.currentUser.EmployeeId == 37 ||
        this.IsInRoles([this.roles.GerenteRRHH])
          ? null
          : this.currentUser.EmployeeId;

      let params = {
        directionId: this.directionId == 0 ? null : this.directionId,
        year: this.year == 0 ? null : this.year,
        Period: this.year == 0 ? null : this.year,
        EmployeeID: employeeID
      };
      this.$http
        .get("/api/Modules/GetVacationsList", { params })
        .then((resp) => {
          this.VacationData = resp.data;
          this.VacationData.forEach((waos) => {
            waos.OpenDetailVacaciones = this.OpenDetailVacaciones;
          });
        })
        .finally(() => {
          this.autoLoading = false;
        });

      if (
        this.currentUser.EmployeeId == 196 ||
        this.currentUser.EmployeeId == 220 ||
        this.IsInRoles([this.roles.GerenteRRHH])
      ) {
        this.AllowCreateVacations = true;
      } else {
        this.AllowCreateVacations = false;
      }

      this.getUser();
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    openDrawerVacaciones() {
      this.drawerVacaciones = true;
    },

    closeDrawerVacaciones() {
      this.drawerVacaciones = false;
      this.getDataVacations();
    },

    closeDrawerDetalles() {
      this.showDrawerVacationReport = false;
      this.getDataVacations();
    },

    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.getDataVacations();
    },

    handleChangeYear(year) {
      this.year = year;
      this.getDataVacations();
    },

    OpenDetailVacaciones(row, month, years) {
      let mtn;
      switch (month) {
        case "Enero":
          mtn = 1;
          break;
        case "Febrero":
          mtn = 2;
          break;
        case "Marzo":
          mtn = 3;
          break;
        case "Abril":
          mtn = 4;
          break;
        case "Mayo":
          mtn = 5;
          break;
        case "Junio":
          mtn = 6;
          break;
        case "Julio":
          mtn = 7;
          break;
        case "Agosto":
          mtn = 8;
          break;
        case "Septiembre":
          mtn = 9;
          break;
        case "Octubre":
          mtn = 10;
          break;
        case "Noviembre":
          mtn = 11;
          break;
        case "Diciembre":
          mtn = 12;
          break;
        default:
      }
      this.IdUser = row.Id;
      this.Month = mtn;
      this.year2 = years;
      this.showDrawerVacationReport = true;
    },

    getUser() {
      if (
        this.currentUser.EmployeeId == 196 ||
        this.currentUser.EmployeeId == 220 ||
        this.IsInRoles([this.roles.GerenteRRHH])
      ) {
        return;
      } else {
        this.$http
          .get(`/api/Employees?userId=${this.currentUser.UserID}`)
          .then((resp) => {
            this.EmployeeData = resp.data;
            this.InitDateEmployee = resp.data.CreatedAt;
            console.log("CreateDate1: ", this.InitDateEmployee);
            this.PermissionsForCreateVacations();
          });
      }
    },

    PermissionsForCreateVacations() {
      const created = new Date(this.InitDateEmployee);
      const now = new Date();
      const offset = -4; // UTC-4 para República Dominicana
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      const today = new Date(utc + offset * 3600000);
      const diffMs = today - created;
      const msPerYear = 1000 * 60 * 60 * 24 * 365.25;
      const years = diffMs / msPerYear;
      const fullYears = Math.floor(years);

      if (fullYears < 1) {
        this.AllowCreateVacations = false;
        return;
      }

      // Último aniversario
      const lastAnniversary = new Date(created);
      lastAnniversary.setFullYear(lastAnniversary.getFullYear() + fullYears);

      // Seis meses después del aniversario
      const sixMonthsAfter = new Date(lastAnniversary);
      sixMonthsAfter.setMonth(sixMonthsAfter.getMonth() + 6);

      if (today >= lastAnniversary && today <= sixMonthsAfter) {
        this.AllowCreateVacations = true;
      } else {
        this.AllowCreateVacations = false;
      }
    }
  },
  mounted() {
    this.getDataVacations();
  },
  watch: {
    refresh() {
      this.getDataVacations();
    }
  }
};
</script>

<style></style>
